import React from 'react';
import CallConversationSelectionContainer from './CallConversationSelectionContainer';
import TriggerIconButton from 'components/triggers/TriggerIconButton';
import CloseIcon from 'components/pure/utils/icon/CloseIcon';
import {CallConditionType} from 'records/CallTrigger';
import classnames from 'classnames';

class CallConversationSelectionViewRow extends React.Component {
  constructor(props) {
    super(props);

    this.showSelection = this.showSelection.bind(this);
    this.closeSelection = this.closeSelection.bind(this);
    this.saveSelection = this.saveSelection.bind(this);

    this.state = {
      selectionVisible: false,
      previousContext: null,
    };
  }

  showSelection() {
    this.setState({
      selectionVisible: true,
    });
  }

  closeSelection() {
    this.setState({
      selectionVisible: false,
    });
    this.state.previousContext && this.props.updateContext(this.state.previousContext);
  }

  saveSelection(context, close = true) {
    if (close) {
      this.setState({
        selectionVisible: false,
        previousContext: context,
      });
    }

    this.props.updateContext(context);
  }

  componentDidMount() {
    if (this.props.context) {
      this.setState({previousContext: this.props.context});
    }
  }

  renderDescription(context, label, defaultText) {
    if (context.type === CallConditionType.CONVERSATION_LENGTH) {
      return (
        <CallConversationLengthViewComponent
          context={context}
          label={label}
          onClick={this.showSelection}
        />
      );
    }
    if (context.type === CallConditionType.CALL_SCHEDULED && context.scheduled === true) {
      return (
        <CallConversationScheduledViewComponent
          context={context}
          label={label}
          onClick={this.showSelection}
        />
      );
    }
    if (context.type === CallConditionType.CALL_SCHEDULED && context.scheduled === false) {
      return (
        <CallConversationUnscheduledViewComponent
          context={context}
          label={label}
          onClick={this.showSelection}
        />
      );
    }
    if (context.type === CallConditionType.TALK_LISTEN_RATIO) {
      return (
        <CallConversationTalkListenViewComponent
          context={context}
          label={label}
          onClick={this.showSelection}
        />
      );
    }
    if (context.type === CallConditionType.INTERCHANGES) {
      return (
        <CallConversationInterchangesViewComponent
          context={context}
          label={label}
          onClick={this.showSelection}
        />
      );
    }

    return <span>{defaultText}</span>;
  }

  render() {
    const {context, label, defaultText} = this.props;
    const {selectionVisible} = this.state;
    return (
      <div className="call-conversation-selection-view">
        {this.renderDescription(context, label, defaultText)}
        {selectionVisible && (
          <div className="create-rule-popout edit-popout">
            <CallConversationSelectionContainer
              saveSelection={this.saveSelection}
              updateSelection={context => this.saveSelection(context, false)}
              closeRequest={this.closeSelection}
              selectedContextType={context && context.type}
              selectedValue={context && context.getValue()}
            />
          </div>
        )}
      </div>
    );
  }
}

class CallConversationLengthViewComponent extends React.Component {
  render() {
    const {context, label} = this.props;
    const lower = (context.timeRange.start / 60).toFixed(0);
    const upper = (context.timeRange.end / 60).toFixed(0);
    return (
      <span>
        {label}the call length is between{' '}
        <span className="condition-action" onClick={this.props.onClick}>
          {Math.round(lower)} and {Math.round(upper)} minutes
        </span>
      </span>
    );
  }
}

class CallConversationScheduledViewComponent extends React.Component {
  render() {
    const {label} = this.props;
    return (
      <span>
        {label}the call is (likely){' '}
        <span className="condition-action" onClick={this.props.onClick}>
          scheduled
        </span>
      </span>
    );
  }
}

class CallConversationUnscheduledViewComponent extends React.Component {
  render() {
    const {label} = this.props;
    return (
      <span>
        {label}the call is (likely){' '}
        <span className="condition-action" onClick={this.props.onClick}>
          unscheduled
        </span>
      </span>
    );
  }
}

class CallConversationTalkListenViewComponent extends React.Component {
  render() {
    const {context, label} = this.props;
    const range = context.percentRange;
    return (
      <span>
        {label}the caller{' '}
        <span className="condition-action" onClick={this.props.onClick}>
          talked{' '}
          {range.start === range.end
            ? `${range.start}% of the call`
            : `between ${range.start}% and ${range.end}% of the call`}
        </span>
      </span>
    );
  }
}

class CallConversationInterchangesViewComponent extends React.Component {
  render() {
    const {context, label} = this.props;
    return (
      <span>
        {label}there is an average{' '}
        {context.exchangeRange.start === context.exchangeRange.end ? (
          <span className="condition-action" onClick={this.props.onClick}>
            of {context.exchangeRange.start} interchanges per minute
          </span>
        ) : (
          <span className="condition-action" onClick={this.props.onClick}>
            of between {context.exchangeRange.start} to {context.exchangeRange.end} interchanges per
            minute
          </span>
        )}
      </span>
    );
  }
}

class CallConversationSelectionView extends React.Component {
  render() {
    const {matchAny, newContext, defaultText} = this.props;

    return (
      <div className="rule-option-list rule-context-view">
        <ul>
          {matchAny &&
            matchAny.map((context, i) => (
              <li key={i}>
                <CallConversationSelectionViewRow
                  context={context}
                  label={i > 0 ? 'or ' : ''}
                  updateContext={newContext => this.props.updateItem(i, newContext)}
                />
                {i === matchAny.size - 1 && (
                  <div className="or-button" onClick={this.props.orClick}>
                    or
                  </div>
                )}
                <div className="delete" onClick={() => this.props.removeItem(i)}>
                  <CloseIcon />
                </div>
              </li>
            ))}
          {newContext != null && (
            <li>
              <CallConversationSelectionViewRow
                context={newContext}
                label={matchAny && matchAny.size > 0 ? 'or ' : ''}
                defaultText={defaultText}
              />
            </li>
          )}
        </ul>
      </div>
    );
  }
}

export default class CallCoversationSelectionViewPlusButton extends React.Component {
  constructor(props) {
    super(props);

    this.toggleSelection = this.toggleSelection.bind(this);
    this.closeSelection = this.closeSelection.bind(this);
    this.saveSelection = this.saveSelection.bind(this);
    this.updateSelection = this.updateSelection.bind(this);
    this.renderDescription = this.renderDescription.bind(this);

    this.state = {
      selectionVisible: false,
      newContext: null,
    };
  }

  toggleSelection() {
    this.props.onSelect(!this.state.selectionVisible);
    const newContext = !this.state.selectionVisible ? {} : null;
    this.setState({
      selectionVisible: !this.state.selectionVisible,
      newContext,
    });
  }

  closeSelection(reason) {
    this.props.onSelect(false);
    this.setState({
      selectionVisible: false,
      newContext: null,
    });
  }

  saveSelection(context) {
    this.props.onSelect(false);
    this.setState({
      selectionVisible: false,
      newContext: null,
    });
    this.props.addItem(context);
  }

  updateSelection(context) {
    this.setState({newContext: context});
  }

  renderDescription() {
    const {newContext, selectionVisible} = this.state;
    const {matchAny} = this.props;
    return (!matchAny || matchAny.size === 0) && newContext == null ? (
      <TriggerIconButton
        className="call-conversation-field"
        label="has talk / listen ratio, interchanges or duration"
        onClick={this.toggleSelection}
        active={selectionVisible}
      />
    ) : (
      <CallConversationSelectionView
        {...this.props}
        orClick={this.toggleSelection}
        newContext={newContext}
        defaultText="has talk / listen ratio, interchanges or duration"
      />
    );
  }

  render() {
    const {selectionVisible} = this.state;
    return (
      <div
        className={classnames(
          'call-conversation-selection-view-plus-button',
          selectionVisible && 'active'
        )}>
        {this.renderDescription()}
        {selectionVisible && (
          <div className="create-rule-popout">
            <CallConversationSelectionContainer
              saveSelection={this.saveSelection}
              updateSelection={this.updateSelection}
              saveOnSelect={false}
              closeRequest={this.closeSelection}
            />
          </div>
        )}
      </div>
    );
  }
}
